<template>
  <el-dialog title="导入数据" :visible.sync="showss" @close="close" width="35%">
    <div>
      <a :href="templateUrl" style="margin-bottom: 10px;display: block"
        >点击下载导入模板</a
      >
      <el-upload
        :limit="limitNum"
        :auto-upload="false"
        accept=".xlsx,.xls"
        :action="UploadUrl()"
        :before-upload="beforeUploadFile"
        :on-change="fileChange"
        :on-exceed="exceedFile"
        :on-success="handleSuccess"
        :on-error="handleError"
        :file-list="fileList"
        :type="type"
      >
        <el-button size="small" type="primary">选择文件</el-button>
      </el-upload>
      <br />
      <el-button size="small" type="primary" @click="uploadFile"
        >立即上传</el-button
      >
      <el-button size="small" @click="closeDialog">取消</el-button>

      <div style="margin-top: 10px;color:red">
        导入前请注意以下几点:<br />
        1. 导入逻辑：增量导入；<br />
        2. 请确认文件是否已经关闭；<br />
        3. 不要修改导入模板中的列名，请注意导入表格中列名的批注；<br />
        4. 若导入文档大小超过1M且导入失败，请拆分成多个文档后重新导入
      </div>
    </div>
  </el-dialog>
</template>

<script>
import axios from "axios";
import { Message, Loading } from "element-ui";

export default {
  props: {
    type: String
  },
  data() {
    return {
      submit: {},
      limitNum: 1, // 上传excell时，同时允许上传的最大数
      fileList: [], // excel文件列表
      show: false,
      showss: true,
      key: "importFile",
      templateUrl: "/static/订单导入模板.xlsx",
      API_MDMCUSTOMER_IMPORT: "/order/importOrder"
    };
  },
  mounted() {
    if (this.type == "order") {
      this.templateUrl = "/static/订单导入模板.xlsx";
    } else {
      this.templateUrl = "/static/架构导入模板.xlsx";
    }
  },
  methods: {
    // 文件超出个数限制时的钩子
    exceedFile(files, fileList) {
      this.$message.warning(
        `只能选择 ${this.limitNum} 个文件，当前共选择了 ${files.length +
          fileList.length} 个`
      );
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {
      this.fileList = fileList;
    },
    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeUploadFile(file) {
      console.log("before upload");
      console.log(file);
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      let size = file.size / 1024 / 1024;
      if (extension !== "xlsx") {
        this.$message.warning("只能上传后缀是.xlsx的文件");
      }
      if (size > 10) {
        this.$message.warning("文件大小不得超过10M");
      }
    },
    // 文件上传成功时的钩子
    handleSuccess(res, file, fileList) {
      this.$message.success("文件上传成功");
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$message.error("文件上传失败");
    },
    UploadUrl: function() {
      // 因为action参数是必填项，我们使用二次确认进行文件上传时，直接填上传文件的url会因为没有参数导致api报404，所以这里将action设置为一个返回为空的方法就行，避免抛错
      return "";
    },
    uploadFile() {
      //   let token = getToken();
      if (this.fileList.length === 0) {
        this.$message.warning("请上传文件");
      } else {
        let urls = "";
        if (this.type == "order") {
          urls = "/order/importOrder";
        } else {
          urls = "/order/importFramework";
        }
        let loading = (loading = Loading.service({
          lock: false,
          text: "上传中...",
          background: "rgba(255,255,255,0.5)"
        }));
        let form = new FormData();
        form.append(this.key, this.fileList[0].raw);
        axios({
          method: "post",
          // baseURL: "https://orderquery.jnj.com.cn/jnj",
          // baseURL: "http://localhost:8089",
          // baseURL: "https://www.jibangsoftware.com:8088",
          // baseURL: "https://orderquery-qa.jnj.com.cn/jnj",
          baseURL: "https://orderquery.kenvue.com.cn/jnj",
          
          url: urls,
          headers: {
            "Content-type": "multipart/form-data"
            // Token: token
          },
          data: form
        }).then(
          res => {
            loading.close();
            if (res.code != 200) {
              Message({ type: "error", message: res.msg });
            } else {
              Message({ type: "success", message: res.msg });
              this.close();
            }
          },
          err => {
            loading.close();
            Message({ type: "error", message: "导入失败" });
            this.close();
          }
        );
      }
    },
    closeDialog() {
      this.$emit("close", null);
    },
    close() {
      this.$emit("close", null);
    }
  },
  watch: {}
};
</script>

<style type="text/css" scoped>
.el-dialog {
  width: fit-content;
}
</style>



// WEBPACK FOOTER //
// src/components/CommonInport.vue